var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE9\xA1\xB5\xE9\x9D\xA2-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System"
  }, /*#__PURE__*/React.createElement("g", {
    id: "information_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    d: "M9.99984 1.66602C14.6022 1.66602 18.3332 5.39697 18.3332 9.99935C18.3332 14.6017 14.6022 18.3327 9.99984 18.3327C5.39746 18.3327 1.6665 14.6017 1.6665 9.99935C1.6665 5.39697 5.39746 1.66602 9.99984 1.66602ZM9.99984 3.33268C6.31794 3.33268 3.33317 6.31745 3.33317 9.99935C3.33317 13.6813 6.31794 16.666 9.99984 16.666C13.6818 16.666 16.6665 13.6813 16.6665 9.99935C16.6665 6.31745 13.6818 3.33268 9.99984 3.33268ZM9.9915 8.33268C10.4563 8.33268 10.8332 8.70952 10.8332 9.17435V13.4442C11.0823 13.5883 11.2498 13.8576 11.2498 14.166C11.2498 14.6263 10.8768 14.9993 10.4165 14.9993H10.0082C9.54325 14.9993 9.1665 14.6225 9.1665 14.1577V9.99935C8.70625 9.99935 8.33317 9.62627 8.33317 9.16602C8.33317 8.70577 8.70625 8.33268 9.1665 8.33268H9.9915ZM9.99984 5.83268C10.4601 5.83268 10.8332 6.20578 10.8332 6.66602C10.8332 7.12625 10.4601 7.49935 9.99984 7.49935C9.53959 7.49935 9.1665 7.12625 9.1665 6.66602C9.1665 6.20578 9.53959 5.83268 9.99984 5.83268Z",
    fill: "#0009E8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.35c1104244682acbb29b602ff4e60615.svg";
export { ForwardRef as ReactComponent };